import { useMutation } from "@tanstack/react-query";
import { Page } from "../types";
import { bulkUpdatePagesListByBrand } from "../api/bulkUpdatePagesListByBrand";
import {
  invalidatePagesListByBrandsQuery,
  setPagesListByBrandQueryData,
  getPagesListByBrandQueryData
} from "./usePagesListByBrandQuery";

export const useReorderPagesQuery = () => {
  return useMutation({
    mutationFn: async ({ brandId, pages }: { brandId: string, pages: Page[] }) => {
      const pagesWithOrder = pages.map((page, index) => ({
        id: page.id,
        order: index + 1
      }));

      const previousData = getPagesListByBrandQueryData(brandId);

      setPagesListByBrandQueryData(brandId, pages);

      await bulkUpdatePagesListByBrand(brandId, pagesWithOrder);

      return previousData;
    },
    onError: (_, { brandId }, previousData?: Page[]) => {
      if (!previousData){
        return;
      }
      setPagesListByBrandQueryData(brandId, previousData);
    },
    onSettled: (data, _, variables) => {
      if (!variables?.brandId) {
        return;
      }
      invalidatePagesListByBrandsQuery(variables.brandId);
    }
  });
};
